import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_306: DocMigration = {
  maxSchemaVersion: "0.0.306",
  description: "Set explicit 0 UV rotation for column sections",
  apply(json: any) {
    if (json.settings) {
      for (const settingId in json.settings) {
        const setting = json.settings[settingId];
        if (setting.type === "COLUMN_CATALOG_SETTINGS") {
          const columnTable = setting.columnTable;
          for (const columnId in columnTable) {
            const column = columnTable[columnId];
            if (column.subType === "ARCHITECTURAL" && column.sections) {
              for (const section of column.sections) {
                if (section.materialRotation === undefined) {
                  section.materialRotation = 0;
                }
              }
            }
          }
        }
      }
    }
    return json;
  },
};

export default migration_0_0_306;
